import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Space,
  Spin,
  DatePicker,
  Col,
  Row,
  Card,
} from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import PageBreadcrumb from "../../component/PageBreadcrumb";
import { UTCToAsiaTimeConverter } from "../../helper/helper";
import { Upcoming } from "../../redux/actions/SessionAction";

const dateFormat = "YYYY-MM-DD";

const BDAUpcomingSession = () => {
  const dispatch = useDispatch();
  var upcomingSession = useSelector((state) => state.SessionReducer.upcoming);
  const [date, setDate] = useState(moment(new Date()).format(dateFormat));
  const [loading, setLoading] = useState(false);

  // Filter sessions to show only BDA demo sessions
  const bdaDemoSessions = upcomingSession?.filter(
    (session) => session.isBdaDemoSession === true
  ) || [];

  function onPickDate(date, dateString) {
    setDate(dateString);
  }

  const fetchUpcomingSession = () => {
    setLoading(true);
    var data = {
      date: date,
      type: "Demo",
      page: 1,
      limit: 200,
      timezone: "Asia/Kolkata",
    };

    dispatch(Upcoming(data));
  };

  useEffect(() => {
    fetchUpcomingSession();
  }, []);

  // Update loading state when Redux state changes
  useEffect(() => {
    if (upcomingSession !== undefined) {
      setLoading(false);
    }
  }, [upcomingSession]);

  const columns = [
    {
      title: "Sl No",
      dataIndex: "slNo",
      key: "slNo",
      width: 70,
    },
    {
      title: "Teacher name",
      dataIndex: "teacherName",
      key: "teacherName",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Meeting URL",
      key: "joiningLink",
      fixed: "right",
      width: 150,
      render: ({ joiningLink }) => (
        <a href={joiningLink} target="_blank" rel="noopener noreferrer">
          Join meeting
        </a>
      ),
    },
    {
      title: "Start Meeting URL",
      key: "startMeetingUrl",
      fixed: "right",
      width: 150,
      render: ({ startMeetingUrl }) => (
        <a href={startMeetingUrl} target="_blank" rel="noopener noreferrer">
          Start meeting
        </a>
      ),
    },
  ];

  const sessionDetails =
    bdaDemoSessions?.map((data, i) => ({
      key: i,
      slNo: i + 1,
      teacherName: data?.teacher?.name || "N/A",
      type: data.type || "Demo",
      subject: data.subjects || "N/A",
      date: moment(new Date(data.sessionDate)).format("YYYY-MM-DD"),
      time:
        UTCToAsiaTimeConverter(data.startTime) +
        " - " +
        UTCToAsiaTimeConverter(data.endTime),
      joiningLink: data.joinMeetingUrl || "#",
      startMeetingUrl: data.startMeetingUrl || "#",
    })) || [];

  return (
    <div>
      <PageBreadcrumb route={["BDA", "Upcoming Sessions"]} />
      <Card title="Filter Session" style={{ marginBottom: "1rem" }}>
        <Row>
          <Col span={20}>
            <Space>
              <DatePicker
                onChange={onPickDate}
                defaultValue={moment(new Date(), dateFormat)}
                format={dateFormat}
              />
              <Button
                type="primary"
                onClick={() => {
                  fetchUpcomingSession();
                }}
                loading={loading}
              >
                Search
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>
      {loading ? (
        <div className="spin-center">
          <Spin size="large" />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={sessionDetails}
          scroll={{ x: 1400 }}
          pagination={false}
        />
      )}
    </div>
  );
};

export default BDAUpcomingSession;

